import { mapMutations, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('breadcrumbs', [
            'breadcrumbs',
        ])
    },
    methods: {
        ...mapMutations('breadcrumbs', [
            'mutation_breadcrumbs',
        ]),
        update_breadcrumbs_title(title) {
            console.log('update_breadcrumbs_title: ', title)
            let new_breadcrumbs = this.breadcrumbs.slice()
            new_breadcrumbs[new_breadcrumbs.length-1]['name'] = title
            this.mutation_breadcrumbs(new_breadcrumbs)
        }
    },
    created () {
        if (this.$route && this.$route.meta && this.$route.meta['breadcrumbs']) {
            this.mutation_breadcrumbs(this.$route.meta['breadcrumbs'](this.$route.params))
        }
    }
}